import {Fragment, type ReactNode} from "react";
import classNames from "classnames";

import type {IHighlightedTextProps} from "../types/IHighlightedTextProps";

import * as styles from "./HighlightedText.module.css";

/** Renders `text` with the matched ranges in SemiBold (`<mark>` without the default background). */
export const HighlightedText = (props: IHighlightedTextProps) => {
    const {text, ranges, className, markClassName} = props;
    const parts: ReactNode[] = [];
    let cursor = 0;

    for (const range of ranges) {
        const start = Math.max(range.start, cursor);
        const end = Math.min(range.end, text.length);

        if (end <= start) {
            continue;
        }

        if (start > cursor) {
            parts.push(<Fragment key={`text-${cursor}`}>{text.slice(cursor, start)}</Fragment>);
        }

        parts.push(
            <mark key={`mark-${start}`} className={classNames(styles.mark, markClassName)}>
                {text.slice(start, end)}
            </mark>
        );
        cursor = end;
    }

    if (cursor < text.length) {
        parts.push(<Fragment key={`text-${cursor}`}>{text.slice(cursor)}</Fragment>);
    }

    return <span className={className}>{parts}</span>;
};
import {Fragment, type ReactNode} from "react";
import classNames from "classnames";

import type {IHighlightedTextProps} from "../types/IHighlightedTextProps";

import * as styles from "./HighlightedText.module.css";

/** Renders `text` with the matched ranges in SemiBold (`<mark>` without the default background). */
export const HighlightedText = (props: IHighlightedTextProps) => {
    const {text, ranges, className, markClassName} = props;
    const parts: ReactNode[] = [];
    let cursor = 0;

    for (const range of ranges) {
        const start = Math.max(range.start, cursor);
        const end = Math.min(range.end, text.length);

        if (end <= start) {
            continue;
        }

        if (start > cursor) {
            parts.push(<Fragment key={`text-${cursor}`}>{text.slice(cursor, start)}</Fragment>);
        }

        parts.push(
            <mark key={`mark-${start}`} className={classNames(styles.mark, markClassName)}>
                {text.slice(start, end)}
            </mark>
        );
        cursor = end;
    }

    if (cursor < text.length) {
        parts.push(<Fragment key={`text-${cursor}`}>{text.slice(cursor)}</Fragment>);
    }

    return <span className={className}>{parts}</span>;
};
